import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
    <p><strong>Description</strong></p>
    <h4 id="HProxemicsDataUsePolicy"><span>Proxemics Data Use Policy</span></h4>
    <p>
      The data provided through the Proxemics program is intended to provide insights to on-site leadership teams to assist
      them in identifying areas in which they need to increase their focus. Information provided in this action, or any
      other supporting dashboard, <strong>should not</strong> be used for any corrective action.
    </p>
    <p>If social distancing opportunities are observed, leadership <strong>should</strong> take the following action(s):</p>
    <ul>
      <li>Engage employees and emphasize that social distancing policies are in place for their own health and safety as
        well as others in the facility.
      </li>
      <li>Identify and address any opportunities to improve area organization to promote 6ft/2m distancing.</li>
      <li>Identify and address any process gaps which may be causing large groups of employees to congregate in certain
        areas of the building.
      </li>
      <li>If through direct observations and seek to understand conversations it is determined that associates are electing
        not to comply with social distancing policies, partner with a Senior leader and HRBP to determine next steps.
      </li>
    </ul>
    <p><strong>Resolution Steps</strong></p>
    <ol>
      <li>Identify the location under "Action Details". 15 or more people were identified in this location and there is
        likely opportunity to improve social distancing.
      </li>
      <li>Go to the specified location.</li>
      <li>Update additional inputs with findings.</li>
      <li>Change the action status to "closed" and hit the update button.</li>
    </ol>
    <p><strong>Supplemental Links</strong></p>
    <p>
      1) <span className="wikiinternallink"><a rel=" noopener noreferrer" target="_blank"
                                               href="https://pe.corp.amazon.com/covid_sd">PETS Proxemics Dashboard</a></span>
    </p>
    <p>
      2) <span className="wikiinternallink"><a rel="noopener noreferrer" target="_blank"
                                               href="https://w.amazon.com/bin/view/ManagersReferenceGuide/ATLAS/ActionCenter/SocialDistancing/#HFAQ:">Proxemics FAQ</a></span>
    </p>
    <p>
      3) <span className="wikiinternallink"><a rel="noopener noreferrer" target="_blank"
                                               href="https://sim.amazon.com/issues/create?assignedFolder=d22979fa-bf2a-4f14-845e-1382f6c59118">Submit a SIM</a></span>
    </p>
    <div className="wikimodel-emptyline"></div>
    <p>
        <span className="wikiinternallink">
            <a href="https://pe.corp.amazon.com/covid_sd?fc=DYO2"><span style="font-size: 10.5pt; font-family: ;">PETS Proximity Metrics Dashboard</span></a>
        </span>
    </p>
    <ul style="list-style-type: circle;">
      <li>
            <span
              style="background: white; color: rgb(51, 51, 51); tab-stops: list 1in; font-size: 10.5pt; font-family: 'Helvetica', sans-serif;">
                It is important to review all the images to understand where our area(s) of opportunity are and create specific actions to address any behavioral, process, or layout issues that caused reduced distancing.
            </span>
      </li>
      <li>
        <span
          style="background: white; color: rgb(51, 51, 51); tab-stops: list 1in; font-size: 10.5pt; font-family: 'Helvetica', sans-serif;">In the comments section please copy and paste one of the following:</span>
        <ul style="list-style-type: square;">
          <li>
            <span
              style="background: white; color: rgb(51, 51, 51); tab-stops: list 1.5in; font-size: 10.5pt; font-family: 'Helvetica', sans-serif;">Process related issue (overstaffing/standard work violation/ops clock deviation)</span>
          </li>
          <li><span
            style="background: white; color: rgb(51, 51, 51); tab-stops: list 1.5in; font-size: 10.5pt; font-family: 'Helvetica', sans-serif;">5s or layout issue</span>
          </li>
          <li><span
            style="background: white; color: rgb(51, 51, 51); tab-stops: list 1.5in; font-size: 10.5pt; font-family: 'Helvetica', sans-serif;">Behavioral – Coaching opportunity</span>
          </li>
          <li><span
            style="background: white; color: rgb(51, 51, 51); tab-stops: list 1.5in; font-size: 10.5pt; font-family: 'Helvetica', sans-serif;">Other – (enter description here)</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>`
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_SD_Immediate_Action_Needed.jsx